"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATION_DATA = exports.SAMPLE_DATA_CITY_LEVEL = exports.SAMPLE_DATA = exports.PASSENGER_STEPPER_CONFIG = exports.MULTI_CURRENCY_DATA = exports.FEATURE_FLAG_DATA = exports.ENDPOINT_CONFIG_V3 = exports.ENDPOINT_CONFIG = exports.DESTINATION_DATA = exports.DEFAULT_DATA = exports.CONTEXTUAL_CONFIG = exports.CHANNEL_HASH_DATA = void 0;
var SAMPLE_DATA = {
  components: [{
    data0: [{
      type: 'heroBanner',
      id: 'heroBanner',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: 'www.airasia.com',
      placeholderText: '',
      showInDesktop: 'FALSE',
      showInMobile: 'TRUE'
    }, {
      type: 'trip_type',
      id: 'trip_type',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }, {
      type: 'passenger_counter',
      id: 'passenger_counter',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'FALSE'
    }, {
      type: 'promoCode',
      id: 'promoCode',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: 'Promo code',
      showInDesktop: 'TRUE',
      showInMobile: 'FALSE'
    }, {
      type: 'checkbox',
      id: 'big_points',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'FALSE'
    }, {
      type: 'snapCheckbox',
      id: 'snapCheckbox',
      iconName: '',
      label1: 'SNAP (Flights + Hotel)',
      label2: 'Check out the savings you get when adding a hotel',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'FALSE'
    }]
  }, {
    data1: [{
      type: 'placepicker',
      id: 'originDestination',
      iconName: 'locationIcon',
      label1: 'Flying from',
      label2: 'Going to',
      redirectUrl: '',
      placeholderText: 'Try "{0}"',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }, {
      type: 'datepicker',
      id: 'datepicker',
      iconName: 'calendarIcon',
      label1: 'Depart',
      label2: 'Return',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }, {
      type: 'passenger_counter',
      id: 'passenger_counter',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'FALSE',
      showInMobile: 'TRUE'
    }, {
      type: 'promoCode',
      id: 'promoCode',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: 'Enter Promocode',
      showInDesktop: 'FALSE',
      showInMobile: 'TRUE'
    }, {
      type: 'checkbox',
      id: 'big_points',
      iconName: '',
      label1: 'Redeem BIG Points',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'FALSE',
      showInMobile: 'TRUE'
    }, {
      type: 'button',
      id: 'search_button',
      iconName: '',
      label1: 'Search',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }]
  }],
  badges: [{
    data: [{
      type: 'city',
      label: 'City',
      icon: 'locationIcon'
    }, {
      type: 'airport',
      label: 'Airport',
      icon: 'airplaneIcon'
    }, {
      type: 'hotel',
      label: 'Hotel',
      icon: 'hoteIcon'
    }, {
      type: 'landmark',
      label: 'Landmark',
      icon: 'golfIcon'
    }]
  }],
  passengerConfig: [{
    data: [{
      min: '1',
      max: '9'
    }]
  }, {
    adult: [{
      min: '1',
      max: ''
    }]
  }, {
    child: [{
      min: '0',
      max: ''
    }]
  }, {
    infant: [{
      min: '0',
      max: 'adult'
    }]
  }],
  placepickerConfig: [{
    cookie: [{
      recentSearchCookie: 'flightRecentSearch'
    }]
  }, {
    recommendedStations: [{
      stationName: 'Singapore'
    }, {
      stationName: 'Kuala Lumpur'
    }, {
      stationName: 'India'
    }, {
      stationName: 'Europe'
    }]
  }],
  gtmConfig: [{
    data: [{
      event: 'trackEventNoEcommerce',
      eventActionClick: 'click',
      eventActionView: 'view',
      eventCategory: '',
      eventLabelCardClick: '',
      eventLabelHeadlineClick: ''
    }]
  }],
  translations: [{
    data: [{
      calendarSubmitButton: 'Confirm',
      calendarResetButton: 'Reset',
      adultSingle: 'Adult',
      adultPlural: 'Adults',
      childSingle: 'Child',
      childPlural: 'Children',
      airAsiaOnly: 'Airasia Flight Only',
      infantSingle: 'Infant',
      infantPlural: 'Infants',
      guestSingle: '{{count}} Guest',
      guestPlural: '{{count}} Guests',
      roomSingle: 'Room',
      roomPlural: 'Rooms',
      adultAgeLimit: '18 years and above',
      childAgeLimit: '2 to 17 years',
      infantAgeLimit: 'Below 2 years',
      roomTitle: 'Room {0}',
      roomAddButton: 'Add more rooms',
      roomRemoveButton: 'Remove',
      roomSubmitButton: 'Done',
      noResultLabel: 'There is no result for {0}',
      lowestFareLabel: 'Lowest all-in fares in {0} for 1 adult',
      noFareLabel: 'Unable to display the lowest fares',
      passengerModalHeaderLabel: 'Select guests and rooms',
      bigLoyaltyToggleLabel: 'Redeem BIG Points',
      recentSearchLabel: 'Recent searches',
      nearestAirportLabel: 'Nearest airport',
      loadOptions: 'Options are loading',
      paxSelectorLabel: 'Guests and travel class',
      tripTypeMobileHeaderLabel: 'Journey Type',
      heroBannerUrl: 'https://a.staticaa.com/images/web-apps/component/flight-search/Generic-Flight-Mobile-Web-Banner.png',
      snapCheckboxTitle: 'SNAP (Flights + Hotel)',
      snapCheckboxLabel: 'Check out the savings you get when adding a hotel',
      travelClassTitle: 'Travel Class'
    }]
  }],
  chinaDisclaimer: [{
    data: [{
      cnDisclaimerLine1: '请稍候，您将于 {3} 秒后由 {0} 网站跳转至中国境外网站 {1}。',
      cnDisclaimerLine2: '您的交易是直接与中国境外网站 {1} 的运营主体 {2} 构成合同关系，与亚航商务服务(广州)有限公司无关。',
      cnDisclaimerURL: 'airasia.cn',
      countDownTimer: '5',
      redirectCompanyName: 'AirAsiaCom Travel Sdn Bhd',
      redirectCompanyURL: 'airasia.com',
      redirectionUrl: 'https://china.airasiago.com/lp/dailydeals?' + 'langid=2052&utm_source=airasia_web&utm_medium=product_tile&utm_campaign=SAH&utm_content=zh-CN',
      productID: 'flights',
      newTab: 'TRUE'
    }]
  }],
  aaiDisclaimer: [{
    data: [{
      cnDisclaimerLine1: 'Just a moment. We’re redirecting you to airasia.co.in in {3} seconds.',
      cnDisclaimerLine2: ' ',
      cnDisclaimerURL: 'airasia.co.in',
      countDownTimer: '5',
      redirectCompanyName: 'AirAsiaIndia',
      redirectCompanyURL: 'airasia.co.in',
      redirectionUrl: '',
      productID: 'flights',
      newTab: 'TRUE'
    }]
  }],
  ENDPOINT_CONFIG: [{
    data: [{
      id: 'origin',
      endpointID: 'origin',
      endpointUrl: '{static_url}/station/v2/{locale}/file.json'
    }, {
      id: 'destination',
      endpointID: 'destination',
      endpointUrl: '{static_url}/v2/destination/{iata}/file.json'
    }, {
      id: 'datepicker',
      endpointID: 'oneway',
      endpointUrl: ''
    }, {
      id: 'datepicker',
      endpointID: 'return',
      endpointUrl: ''
    }, {
      id: 'dateFormat',
      endpointID: 'dateFormat',
      endpointUrl: '{gcs_url}/dataformat/date/{locale}/file.json'
    }, {
      id: 'multiCurrency',
      endpointID: 'multiCurrency',
      endpointUrl: '{kong_url}/multicurrency/{currency}'
    }, {
      id: 'nearestAirport',
      endpointID: 'nearestAirport',
      endpointUrl: 'https://t.airasia.com/nearestairport/airport/user'
    }, {
      id: 'featureFlag',
      endpointID: 'featureFlag',
      endpointUrl: '{static_url}/cosmos/featureflags/hercules/{feature_flag_env}/file.json'
    }, {
      id: 'searchDeepLink',
      endpointID: 'searchDeepLink',
      endpointUrl: '{kong_url}/deeplink/v1/encryptdeeplink'
    }, {
      id: 'dataVisor',
      endpointID: 'dataVisor',
      endpointUrl: '{kong_url}/bizsecrisk'
    }, {
      id: 'baseCurrency',
      endpointID: 'baseCurrency',
      endpointUrl: '{kong_url}/basecurrency/{IATA}'
    }, {
      id: 'originCity',
      endpointID: 'origin',
      endpointUrl: '{static_url}/flights/station/v3/{locale}/file.json'
    }, {
      id: 'destinationCity',
      endpointID: 'destination',
      endpointUrl: '{static_url}/flights'
    }, {
      id: 'airportSearch',
      endpointID: 'airportSearch',
      endpointUrl: '{flights_api_url}/travel/stations'
    }]
  }],
  tripTypeConfig: [{
    data: [{
      label: 'Return',
      selectionType: 'select',
      code: 'R',
      url: ''
    }, {
      label: 'One way',
      selectionType: 'select',
      code: 'O',
      url: ''
    }, {
      label: 'Multi-city',
      selectionType: 'redirect',
      code: 'M',
      url: 'https://flybeyond.airasia.com/en/landing/multicity'
    }]
  }],
  calendarConfig: [{
    data: [{
      calendarDays: '510'
    }]
  }],
  snapCheckBoxConfig: [{
    data: [{
      originDestination: '["KUL-PEN","BLR-KUL"]'
    }]
  }],
  travelClassConfig: [{
    data: [{
      title: 'Economy',
      value: 'economy',
      code: 'M'
    }, {
      title: 'Business',
      value: 'business',
      code: 'C'
    }, {
      title: 'Premium Economy',
      value: 'premium',
      code: 'W'
    }, {
      title: 'First Class',
      value: 'first',
      code: 'F'
    }]
  }]
};
exports.SAMPLE_DATA = SAMPLE_DATA;
var SAMPLE_DATA_CITY_LEVEL = {
  components: [{
    data0: [{
      type: 'heroBanner',
      id: 'heroBanner',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: 'www.airasia.com',
      placeholderText: '',
      showInDesktop: 'FALSE',
      showInMobile: 'TRUE'
    }, {
      type: 'trip_type',
      id: 'trip_type',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }, {
      type: 'passenger_counter',
      id: 'passenger_counter',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'FALSE'
    }, {
      type: 'promoCode',
      id: 'promoCode',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: 'Promo code',
      showInDesktop: 'TRUE',
      showInMobile: 'FALSE'
    }, {
      type: 'checkbox',
      id: 'big_points',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'FALSE'
    }, {
      type: 'snapCheckbox',
      id: 'snapCheckbox',
      iconName: '',
      label1: 'SNAP (Flights + Hotel)',
      label2: 'Check out the savings you get when adding a hotel',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'FALSE'
    }]
  }, {
    data1: [{
      type: 'placepicker',
      id: 'originDestination',
      iconName: 'locationIcon',
      label1: 'From',
      label2: 'To',
      label3: 'Flying from',
      label4: 'Going to',
      redirectUrl: '',
      placeholderText: 'Try "{0}"',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }, {
      type: 'datepicker',
      id: 'datepicker',
      iconName: 'calendarIcon',
      label1: 'Depart',
      label2: 'Return',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }, {
      type: 'passenger_counter',
      id: 'passenger_counter',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'FALSE',
      showInMobile: 'TRUE'
    }, {
      type: 'promoCode',
      id: 'promoCode',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: 'Enter Promocode',
      showInDesktop: 'FALSE',
      showInMobile: 'TRUE'
    }, {
      type: 'checkbox',
      id: 'big_points',
      iconName: '',
      label1: 'Redeem BIG Points',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'FALSE',
      showInMobile: 'TRUE'
    }, {
      type: 'button',
      id: 'search_button',
      iconName: '',
      label1: 'Search',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }]
  }],
  badges: [{
    data: [{
      type: 'city',
      label: 'City',
      icon: 'locationIcon'
    }, {
      type: 'airport',
      label: 'Airport',
      icon: 'airplaneIcon'
    }, {
      type: 'hotel',
      label: 'Hotel',
      icon: 'hoteIcon'
    }, {
      type: 'landmark',
      label: 'Landmark',
      icon: 'golfIcon'
    }]
  }],
  passengerConfig: [{
    data: [{
      min: '1',
      max: '9'
    }]
  }, {
    adult: [{
      min: '1',
      max: ''
    }]
  }, {
    child: [{
      min: '0',
      max: ''
    }]
  }, {
    infant: [{
      min: '0',
      max: 'adult'
    }]
  }],
  placepickerConfig: [{
    cookie: [{
      recentSearchCookie: 'flightRecentSearch'
    }]
  }, {
    recommendedStations: [{
      stationName: 'Singapore'
    }, {
      stationName: 'Kuala Lumpur'
    }, {
      stationName: 'India'
    }, {
      stationName: 'Europe'
    }]
  }],
  gtmConfig: [{
    data: [{
      event: 'trackEventNoEcommerce',
      eventActionClick: 'click',
      eventActionView: 'view',
      eventCategory: '',
      eventLabelCardClick: '',
      eventLabelHeadlineClick: ''
    }]
  }],
  translations: [{
    data: [{
      calendarSubmitButton: 'Confirm',
      calendarResetButton: 'Reset',
      adultSingle: 'Adult',
      adultPlural: 'Adults',
      childSingle: 'Child',
      childPlural: 'Children',
      infantSingle: 'Infant',
      infantPlural: 'Infants',
      guestSingle: '{{count}} Guest',
      guestPlural: '{{count}} Guests',
      roomSingle: 'Room',
      roomPlural: 'Rooms',
      adultAgeLimit: '18 years and above',
      childAgeLimit: '2 to 17 years',
      infantAgeLimit: 'Below 2 years',
      roomTitle: 'Room {0}',
      roomAddButton: 'Add more rooms',
      roomRemoveButton: 'Remove',
      roomSubmitButton: 'Done',
      noResultLabel: 'There is no result for {0}',
      lowestFareLabel: 'Lowest all-in fares in {0} for 1 adult',
      noFareLabel: 'Unable to display the lowest fares',
      passengerModalHeaderLabel: 'Select guests and rooms',
      bigLoyaltyToggleLabel: 'Redeem BIG Points',
      recentSearchLabel: 'Recent searches',
      nearestAirportLabel: 'Nearest airport',
      loadOptions: 'Options are loading',
      paxSelectorLabel: 'Guests and travel class',
      tripTypeMobileHeaderLabel: 'Journey Type',
      airAsiaOnly: 'Airasia Flight Only',
      heroBannerUrl: 'https://a.staticaa.com/images/web-apps/component/flight-search/Generic-Flight-Mobile-Web-Banner.png',
      snapCheckboxTitle: 'SNAP (Flights + Hotel)',
      snapCheckboxLabel: 'Check out the savings you get when adding a hotel',
      travelClassTitle: 'Travel Class'
    }]
  }],
  chinaDisclaimer: [{
    data: [{
      cnDisclaimerLine1: '请稍候，您将于 {3} 秒后由 {0} 网站跳转至中国境外网站 {1}。',
      cnDisclaimerLine2: '您的交易是直接与中国境外网站 {1} 的运营主体 {2} 构成合同关系，与亚航商务服务(广州)有限公司无关。',
      cnDisclaimerURL: 'airasia.cn',
      countDownTimer: '5',
      redirectCompanyName: 'AirAsiaCom Travel Sdn Bhd',
      redirectCompanyURL: 'airasia.com',
      redirectionUrl: 'https://china.airasiago.com/lp/dailydeals?' + 'langid=2052&utm_source=airasia_web&utm_medium=product_tile&utm_campaign=SAH&utm_content=zh-CN',
      productID: 'flights',
      newTab: 'TRUE'
    }]
  }],
  aaiDisclaimer: [{
    data: [{
      cnDisclaimerLine1: 'Just a moment. We’re redirecting you to airasia.co.in in {3} seconds.',
      cnDisclaimerLine2: ' ',
      cnDisclaimerURL: 'airasia.co.in',
      countDownTimer: '5',
      redirectCompanyName: 'AirAsiaIndia',
      redirectCompanyURL: 'airasia.co.in',
      redirectionUrl: '',
      productID: 'flights',
      newTab: 'TRUE'
    }]
  }],
  ENDPOINT_CONFIG: [{
    data: [{
      id: 'origin',
      endpointID: 'origin',
      endpointUrl: 'https://static.stgairasia.com/station/v3/{locale}/file.json'
    }, {
      id: 'destination',
      endpointID: 'destination',
      endpointUrl: 'https://static.stgairasia.com/v3/destination/{iata}/file.json'
    }, {
      id: 'datepicker',
      endpointID: 'oneway',
      endpointUrl: ''
    }, {
      id: 'datepicker',
      endpointID: 'return',
      endpointUrl: ''
    }, {
      id: 'dateFormat',
      endpointID: 'dateFormat',
      endpointUrl: '{gcs_url}/dataformat/date/{locale}/file.json'
    }, {
      id: 'multiCurrency',
      endpointID: 'multiCurrency',
      endpointUrl: '{kong_url}/multicurrency/{currency}'
    }, {
      id: 'nearestAirport',
      endpointID: 'nearestAirport',
      endpointUrl: 'https://t.airasia.com/nearestairport/airport/user'
    }, {
      id: 'featureFlag',
      endpointID: 'featureFlag',
      endpointUrl: '{static_url}/cosmos/featureflags/hercules/{feature_flag_env}/file.json'
    }, {
      id: 'searchDeepLink',
      endpointID: 'searchDeepLink',
      endpointUrl: '{kong_url}/deeplink/v1/encryptdeeplink'
    }, {
      id: 'dataVisor',
      endpointID: 'dataVisor',
      endpointUrl: '{kong_url}/bizsecrisk'
    }, {
      id: 'baseCurrency',
      endpointID: 'baseCurrency',
      endpointUrl: '{kong_url}/basecurrency/{IATA}'
    }, {
      id: 'originCity',
      endpointID: 'origin',
      endpointUrl: '{static_url}/flights/station/v3/{locale}/file.json'
    }, {
      id: 'destinationCity',
      endpointID: 'destination',
      endpointUrl: '{static_url}/flights'
    }, {
      id: 'airportSearch',
      endpointID: 'airportSearch',
      endpointUrl: '{flights_api_url}/travel/stations'
    }]
  }],
  tripTypeConfig: [{
    data: [{
      label: 'Return',
      selectionType: 'select',
      code: 'R',
      url: ''
    }, {
      label: 'One way',
      selectionType: 'select',
      code: 'O',
      url: ''
    }, {
      label: 'Multi-city',
      selectionType: 'redirect',
      code: 'M',
      url: 'https://flybeyond.airasia.com/en/landing/multicity'
    }]
  }],
  calendarConfig: [{
    data: [{
      calendarDays: '510'
    }]
  }],
  travelClassConfig: [{
    data: [{
      title: 'Economy',
      value: 'economy',
      code: 'M'
    }, {
      title: 'Business',
      value: 'business',
      code: 'C'
    }, {
      title: 'Premium Economy',
      value: 'premium',
      code: 'W'
    }, {
      title: 'First Class',
      value: 'first',
      code: 'F'
    }]
  }]
};
exports.SAMPLE_DATA_CITY_LEVEL = SAMPLE_DATA_CITY_LEVEL;
var ENDPOINT_CONFIG = [{
  id: 'origin',
  endpointID: 'origin',
  endpointUrl: '{static_url}/flights/station/v2/{locale}/file.json'
}, {
  id: 'destination',
  endpointID: 'destination',
  endpointUrl: '{static_url}/flights/v2/destination/{iata}/file.json'
}, {
  id: 'datepicker',
  endpointID: 'oneway',
  endpointUrl: ''
}, {
  id: 'datepicker',
  endpointID: 'return',
  endpointUrl: ''
}, {
  id: 'dateFormat',
  endpointID: 'dateFormat',
  endpointUrl: '{static_url}/cosmos/common/date/{locale}/file.json'
}, {
  id: 'multiCurrency',
  endpointID: 'multiCurrency',
  endpointUrl: '{kong_url}/multicurrency/{currency}'
}, {
  id: 'nearestAirport',
  endpointID: 'nearestAirport',
  endpointUrl: 'https://t.airasia.com/nearestairport/airport/user'
}, {
  id: 'featureFlag',
  endpointID: 'featureFlag',
  endpointUrl: '{static_url}/flights/platform/featureflags/search/{feature_flag_env}/file.json'
}, {
  id: 'searchDeepLink',
  endpointID: 'searchDeepLink',
  endpointUrl: '{kong_url}/deeplink/v1/encryptdeeplink'
}, {
  id: 'dataVisor',
  endpointID: 'dataVisor',
  endpointUrl: '{kong_url}/bizsecrisk'
}, {
  id: 'baseCurrency',
  endpointID: 'baseCurrency',
  endpointUrl: '{kong_url}/basecurrency/{IATA}'
}, {
  id: 'otaGeoidFunnel',
  endpointID: 'otaGeoidFunnel',
  endpointUrl: '{static_url}/flights/ota/geoid/geoids/file.json'
}, {
  id: 'originCity',
  endpointID: 'origin',
  endpointUrl: '{static_url}/flights/station/v3/{locale}/file.json'
}, {
  id: 'destinationCity',
  endpointID: 'destination',
  endpointUrl: '{static_url}/flights'
}, {
  id: 'airportSearch',
  endpointID: 'airportSearch',
  endpointUrl: '{flights_api_url}/travel/stations'
}];
exports.ENDPOINT_CONFIG = ENDPOINT_CONFIG;
var ENDPOINT_CONFIG_V3 = [{
  id: 'origin',
  endpointID: 'origin',
  endpointUrl: 'https://static.stgairasia.com/flights/station/v3/{locale}/file.json'
}, {
  id: 'destination',
  endpointID: 'destination',
  endpointUrl: 'https://static.stgairasia.com/flights/v3/destination/{iata}/file.json'
}, {
  id: 'datepicker',
  endpointID: 'oneway',
  endpointUrl: ''
}, {
  id: 'datepicker',
  endpointID: 'return',
  endpointUrl: ''
}, {
  id: 'dateFormat',
  endpointID: 'dateFormat',
  endpointUrl: '{static_url}/cosmos/common/date/{locale}/file.json'
}, {
  id: 'multiCurrency',
  endpointID: 'multiCurrency',
  endpointUrl: '{kong_url}/multicurrency/{currency}'
}, {
  id: 'nearestAirport',
  endpointID: 'nearestAirport',
  endpointUrl: 'https://t.airasia.com/nearestairport/airport/user'
}, {
  id: 'featureFlag',
  endpointID: 'featureFlag',
  endpointUrl: '{static_url}/flights/platform/featureflags/search/{feature_flag_env}/file.json'
}, {
  id: 'searchDeepLink',
  endpointID: 'searchDeepLink',
  endpointUrl: '{kong_url}/deeplink/v1/encryptdeeplink'
}, {
  id: 'dataVisor',
  endpointID: 'dataVisor',
  endpointUrl: '{kong_url}/bizsecrisk'
}, {
  id: 'baseCurrency',
  endpointID: 'baseCurrency',
  endpointUrl: '{kong_url}/basecurrency/{IATA}'
}, {
  id: 'otaGeoidFunnel',
  endpointID: 'otaGeoidFunnel',
  endpointUrl: '{static_url}/flights/ota/geoid/geoids/file.json'
}, {
  id: 'originCity',
  endpointID: 'origin',
  endpointUrl: '{static_url}/flights/station/v3/{locale}/file.json'
}, {
  id: 'destinationCity',
  endpointID: 'destination',
  endpointUrl: '{static_url}/flights'
}, {
  id: 'airportSearch',
  endpointID: 'airportSearch',
  endpointUrl: '{flights_api_url}/travel/stations'
}];
exports.ENDPOINT_CONFIG_V3 = ENDPOINT_CONFIG_V3;
var PASSENGER_STEPPER_CONFIG = {
  min: 1,
  max: 9,
  adult: {
    type: 'adult',
    label: 'Adult',
    subLabel: 'Above 12 years',
    min: 'infant'
  },
  child: {
    type: 'child',
    label: 'Child',
    subLabel: 'From 2 to 11 years',
    min: 0
  },
  infant: {
    type: 'infant',
    label: 'Infant',
    subLabel: 'Under 2 years',
    min: 0,
    max: 'adult'
  }
};
exports.PASSENGER_STEPPER_CONFIG = PASSENGER_STEPPER_CONFIG;
var CONTEXTUAL_CONFIG = {
  token: // eslint-disable-next-line max-len
  'Q09OU1VNRVJfTkFNRT1IT01FX0FQUCZSRVBPU0lUT1JZPUNNUyZURU1QTEFURV9OQU1FPW1hc3RlcnRlbXBsYXRlJmVudHJ5X3RpdGxlPUFpckFzaWEgQ2xhc3NpYw=='
};
exports.CONTEXTUAL_CONFIG = CONTEXTUAL_CONFIG;
var STATION_DATA = [{
  AirportName: 'Kuala Lumpur International Airport 2 (klia2)',
  AlternativeName: 'KL',
  CountryCode: 'MY',
  CountryName: 'Malaysia',
  Lat: 2.74333,
  Long: 101.69333,
  PinYin: '',
  StationCode: 'KUL',
  StationName: 'Kuala Lumpur',
  StationType: 'A',
  TimeZone: 'GMT+08:00',
  AAFlight: true
}, {
  AirportName: 'Changi Airport (T1)',
  AlternativeName: '',
  CountryCode: 'SG',
  CountryName: 'Singapore',
  Lat: 1.36139,
  Long: 103.98889,
  PinYin: '',
  StationCode: 'SIN',
  StationName: 'Singapore',
  StationType: 'A',
  TimeZone: 'GMT+08:00',
  AAFlight: true
}, {
  AirportName: 'Istanbul Airport',
  AlternativeName: 'Istanbul Havalimanı',
  CountryCode: 'TR',
  CountryName: 'Turkey',
  Lat: 41.275278,
  Long: 28.751944,
  PinYin: '',
  StationCode: 'IST',
  StationName: 'Istanbul',
  StationType: 'A',
  TimeZone: 'GMT+03:00',
  AAFlight: false
}, {
  AirportName: 'Kempegowda International Airport Bengaluru',
  AlternativeName: 'Bangalore',
  CountryCode: 'IN',
  CountryName: 'India',
  Lat: 12.94556,
  Long: 77.66333,
  PinYin: '',
  StationCode: 'BLR',
  StationName: 'Bengaluru',
  StationType: 'A',
  TimeZone: 'GMT+05:30',
  AAFlight: true
}];
exports.STATION_DATA = STATION_DATA;
var DESTINATION_DATA = {
  0: {
    SIN: {
      MaxDuration: 85,
      MinDuration: 55,
      AAFlight: true,
      Provider: 'AAB'
    },
    BKI: {
      MaxDuration: 165,
      MinDuration: 150,
      AAFlight: true,
      Provider: 'AAB'
    },
    IST: {
      MaxDuration: 165,
      MinDuration: 150,
      AAFlight: true,
      Provider: 'FLYBEYOND'
    },
    BLR: {
      MaxDuration: 165,
      MinDuration: 150,
      AAFlight: true,
      Provider: 'AAI'
    }
  }
};
exports.DESTINATION_DATA = DESTINATION_DATA;
var MULTI_CURRENCY_DATA = {
  AUD: '0.327680000000000000',
  CNY: '1.619500000000000000',
  EUR: '0.208150000000000000',
  GBP: '0.179660000000000000',
  HKD: '1.969600000000000000',
  IDR: '3627.097976800000000000',
  JPY: '27.700000000000000000',
  NZD: '0.347940000000000000',
  PHP: '12.176900000000000000',
  SGD: '0.335900000000000000',
  THB: '7.938000000000000000',
  USD: '0.253770000000000000'
};
exports.MULTI_CURRENCY_DATA = MULTI_CURRENCY_DATA;
var CHANNEL_HASH_DATA = [{
  PRODUCT_ID: 'Flight',
  CHANNEL: 'Shopping',
  PLATFORM: 'Shopping Website ',
  CHANNEL_ID: 'SHOWEBA',
  CHANNEL_HASH: '906a14a4c039ea4af65874742638ddae5c3ec9c6bbc9026eea35f00f'
}];
exports.CHANNEL_HASH_DATA = CHANNEL_HASH_DATA;
var FEATURE_FLAG_DATA = {
  configuration: {
    ENABLE_HOTEL_POSITION: 'TRUE',
    ENABLE_HOTEL_WEB_CURRENCY_SELECTION: 'TRUE',
    ENABLE_TRIPADVISOR_WRAPPER_SERVICE_SNAP_MOBILE: 'FALSE',
    ENABLE_SNAP_DESKTOP_WEB: 'TRUE',
    ENABLE_HOTEL_SEARCH_WIDGET: 'TRUE',
    HOTEL_ENABLE_SEARCH_HEADER: 'TRUE',
    ENABLE_HOMEPAGE_PRODUCTTILES_SHOWALL: 'TRUE',
    SEND_CUSTOMER_INFO_TO_PAYMENT_DEEPLINK: 'TRUE',
    ENABLE_XJ_UNLIMITED_PASS: 'TRUE',
    ENABLE_BIZSEC_RISK_PLATFORM: 'TRUE',
    ENABLE_WECHAT_MINI_PROGRAM: 'TRUE',
    ENABLE_BAGGAGE_OPTIONS: 'TRUE',
    SHOW_BOOKING_CONTACT_DETAILS: 'TRUE',
    ENABLE_SNAP_EXPRESS_CHECKOUT: 'FALSE',
    ENABLE_HOTEL_TRIGGER_GTM_SCRIPT: 'FALSE',
    HOTEL_ENABLE_GUEST_DETAILS_PRICE_BREAKUP_NATIVE: 'TRUE',
    ENABLE_SNAP_IOS_WEBVIEW_VERSIONS: '0.0.0',
    ENABLE_TWO_MEAL: 'FALSE',
    ENABLE_COVID_TOOLTIP: 'FALSE',
    uhf: 'TRUE',
    HOTEL_ENABLE_V2_API: 'TRUE',
    ENABLE_FLIGHTS_SNAP: 'TRUE',
    ENABLE_SOLDOUT_QUEUE: 'TRUE',
    ENABLE_NEW_INSURANCE: 'TRUE',
    ENABLE_MALDIVES_PAX: 'TRUE',
    HOTEL_ENABLE_GUEST_DETAILS_PULL: 'TRUE',
    TOGGLE_HOMEPAGE_MOBILE_TOOLTIP_POSITION: 'TRUE',
    HOTEL_IMAGE_GALLERY_NATIVE: 'TRUE',
    ADD_APSV_SSR: 'TRUE',
    ENABLE_SNAP_SEARCH_MULTIPLE_ROOMS: 'TRUE',
    ENABLE_MEAL_MANDATORY_WHEN_BUNDLE_SELECTED: 'TRUE',
    ENABLE_XSELL_PUBSUB: 'TRUE',
    HOTEL_ENABLE_NPS_WEB: 'TRUE',
    HOTEL_ENABLE_RE_SEARCH_V2_WEB: 'TRUE',
    ENABLE_ADDONS_BUNDLE_V2: 'TRUE',
    ENABLE_SNAP_DEEPLINK: 'FALSE',
    HOTEL_ENABLE_NPS_MOBILE: 'TRUE',
    ENABLE_FLEXI_FARE: 'TRUE',
    HOTEL_ENABLE_FOCUS_HOTEL_HIGHLIGHT: 'TRUE',
    ENABLE_HOTEL_WEB_LANGUAGE_SELECTION: 'TRUE',
    ENABLE_COVID_TEST_AS_ANCILLARY: 'TRUE',
    ENABLE_HOTEL_BOOKING_LEMON: 'TRUE',
    SHOW_SELECT_SKELETON_LOADER: 'TRUE',
    ENABLE_BIGPAY_CHECKOUT_ON_MOBILE_APP: 'FALSE',
    HOTEL_MOBILE_CURRENCY_SELECTION: 'TRUE',
    ENABLE_SNAP_PROMOCODE: 'FALSE',
    'ENABLE-VP-ALACARTE-MEALS': 'TRUE',
    ENABLE_HOMEPAGE_CHINA_DISCLAIMER: 'TRUE',
    ENABLE_ADDONS_SEATPRICE_V2_PAXCOUNT: 'TRUE',
    HOTEL_SSO_AUTO_POPULATE: 'TRUE',
    AVAILABLE_DATES_TASK_QUEUE_DAYS: '10',
    ENABLE_GTM_REDOPTIMIZE: 'TRUE',
    ENABLE_SELECT_COVID_POPOP: 'TRUE',
    HOTEL_IMAGE_GALLERY_WEB: 'TRUE',
    ENABLE_HOTEL_BOOKING: 'TRUE',
    ENABLE_SNAP_IOS: 'TRUE',
    ENABLE_TRIPADVISOR_WRAPPER_SERVICE_SNAP_WEB: 'FALSE',
    ENABLE_GETPRESELECTEDSSR_V3: 'TRUE',
    ENABLE_CABIN_BAGGAGE: 'TRUE',
    ENABLE_FARE_POPUP: 'TRUE',
    ENABLE_ANC_CACHE: 'TRUE',
    HOTEL_ENABLE_GUEST_DETAILS_PRICE_BREAKUP_WEB: 'TRUE',
    ENABLE_SNAP_AVAILABLEDATECALENDER_MOBILE: 'TRUE',
    ENABLE_SNAP_ANDROID_WEBVIEW_VERSIONS: '0.0.0',
    ENABLE_IAM_REQUEST_INTERCEPTOR: 'TRUE',
    HOTEL_ENABLE_PAY_AT_HOTEL_TESTING: 'FALSE',
    ENABLE_SNAP_AVAILABLEDATECALENDER_WEB: 'TRUE',
    ENABLE_HOTEL_LANGUAGE_SUPPORT: 'en-gb,th-th,ms-my,id-id,ja-jp,ko-kr,vi-vn,zh-cn,zh-hk,zh-tw,tr-tr',
    ENABLE_DEALS_PROMOCODE: 'TRUE',
    HOTEL_IMAGE_GALLERY: 'TRUE',
    ENABLE_SNAP_ANDROID_WEBVIEW: 'TRUE',
    ENABLE_HOMEPAGE_PROMOTION_WIDGET: 'TRUE',
    ENABLE_SNAP_MOBILE_WEB: 'TRUE',
    HOTEL_ENABLE_MOBILE_BANNER: 'TRUE',
    SHOW_BOOKING_DETAILS: 'TRUE',
    ENABLE_SNAP_IOS_WEBVIEW: 'TRUE',
    HOTEL_DISABLE_COUNTRY_FILTER: 'TRUE',
    ENABLE_BIGLOYALTY_TOGGLE: 'TRUE',
    ENABLE_SNAP_BANNER_IN_SEARCH_WIDGET: 'TRUE',
    ENABLE_HIPS_GEO_IP: 'FALSE',
    ENABLE_HOMEPAGE_OURSHOP_WIDGET: 'FALSE',
    ENABLE_COVID_BUNDLE: 'TRUE',
    ENABLE_SNAP_ANDROID: 'TRUE',
    ENABLE_CHECKOUT_DEBUG_LOGS: 'TRUE',
    ENABLE_CHECKOUT_HOTEL_NEW_URL: 'TRUE',
    toGGLE_HOMEPAGE_MOBILE_TOOLTIP_POSITION: 'TRUE',
    HOTEL_ENABLE_SUGGESTIONS_NEW_DESIGN: 'TRUE',
    ENABLE_UHFV3: 'TRUE',
    ENABLE_COUPON_CHANGES: 'TRUE',
    ENABLE_NEW_UI_SNAP_SEARCH_WIDGET: 'TRUE',
    HOTEL_ENABLE_MULTIPLE_ROOMS: 'TRUE',
    HOTEL_ENABLE_RE_SEARCH_V2_MOBILE: 'TRUE',
    ENABLE_HOTEL_WEB_IOS: 'FALSE',
    ENABLE_FSK_ANALYSIS: '',
    HOTEL_ENABLE_ROOM_RECOMMENDED: 'TRUE',
    ENABLE_CHINA_DISCLAIMER: 'TRUE',
    ENABLE_LEMON_AGENTS: 'TRUE',
    ENABLE_HOTEL_WEB_ANDROID: 'FALSE',
    ENABLE_SNAP_REDIRECTION: 'TRUE',
    ENABLE_SEARCH_WIDGET_V2: 'TRUE',
    ENABLE_HOTEL_REDIRECT_CTRIP: 'TRUE',
    HIP_BANNER_AB_ENABLE: 'FALSE',
    ENABLE_DEEPLINK: 'TRUE',
    ENABLE_NEW_BIGPAY_BUTTON: 'TRUE',
    ENABLE_HOTEL_SPECIAL_REQUEST: 'TRUE',
    ENABLE_PRESEL_ANC_CACHE: 'TRUE',
    ENABLE_ANC_CACHE_FROM_PRESELECT: 'FALSE',
    HOTEL_ENABLE_NEW_HOTEL_SEARCH_WIDGET: 'TRUE',
    ENABLE_BIGPAY_CHECKOUT: 'TRUE',
    ENABLE_FARE_POPUP_LOGGING: 'TRUE',
    ENABLE_AAI_REDIRECTION: 'TRUE',
    ENABLE_LISTING_APP: 'FALSE',
    ENABLE_LISTING_APP_BY_ROUTE: 'FALSE',
    ENABLE_OTA: 'FALSE',
    ENABLE_UNIFIED_LISTING_EXPERIENCE: 'FALSE',
    ENABLE_FSW_CABIN_CLASS: 'FALSE',
    ENABLE_FUNNEL_CONTROL_SERVICE: 'FALSE',
    ENABLE_AIRPORT_SEARCH_SERVICE: 'FALSE'
  },
  '906a14a4c039ea4af65874742638ddae5c3ec9c6bbc9026eea35f00f': {
    '': '',
    feedback: '',
    breadcrumb: '',
    CHANNEL_ID: '',
    login: '',
    big_loyalty_widget: ''
  }
};
/**
 * Please don't change
 *
 * This is a dump from this endpoint https://static.stgairasia.com/cosmos/universalsearchwidget/flight/en-gb/file.json
 * which will be used by default in case API fail and no `data` and `endpointconfig` prop passed to the widget
 *
 */

exports.FEATURE_FLAG_DATA = FEATURE_FLAG_DATA;
var DEFAULT_DATA = {
  components: [{
    data0: [{
      type: 'heroBanner',
      id: 'heroBanner',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: 'www.airasia.com',
      placeholderText: '',
      showInDesktop: 'FALSE',
      showInMobile: 'TRUE'
    }, {
      type: 'trip_type',
      id: 'trip_type',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }, {
      type: 'passenger_counter',
      id: 'passenger_counter',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'FALSE'
    }, {
      type: 'promoCode',
      id: 'promoCode',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: 'Promo code',
      showInDesktop: 'TRUE',
      showInMobile: 'FALSE'
    }, {
      type: 'checkbox',
      id: 'big_points',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'FALSE'
    }, {
      type: 'snapCheckbox',
      id: 'snapCheckbox',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'FALSE'
    }]
  }, {
    data1: [{
      type: 'placepicker',
      id: 'originDestination',
      iconName: 'locationIcon',
      label1: 'From',
      label2: 'To',
      redirectUrl: '',
      placeholderText: 'Try "{0}"',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }, {
      type: 'datepicker',
      id: 'datepicker',
      iconName: 'calendarIcon',
      label1: 'Depart',
      label2: 'Return',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }, {
      type: 'passenger_counter',
      id: 'passenger_counter',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'FALSE',
      showInMobile: 'TRUE'
    }, {
      type: 'promoCode',
      id: 'promoCode',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: 'Promo code',
      showInDesktop: 'FALSE',
      showInMobile: 'TRUE'
    }, {
      type: 'checkbox',
      id: 'big_points',
      iconName: '',
      label1: 'Redeem BIG Points',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'FALSE',
      showInMobile: 'TRUE'
    }, {
      type: 'button',
      id: 'search_button',
      iconName: '',
      label1: 'Search',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }]
  }],
  badges: [{
    data: [{
      type: 'city',
      label: 'City',
      icon: 'locationIcon'
    }, {
      type: 'airport',
      label: 'Airport',
      icon: 'airplaneIcon'
    }, {
      type: 'hotel',
      label: 'Hotel',
      icon: 'hoteIcon'
    }, {
      type: 'landmark',
      label: 'Landmark',
      icon: 'golfIcon'
    }]
  }],
  passengerConfig: [{
    data: [{
      min: '1',
      max: '9'
    }]
  }, {
    adult: [{
      min: '1',
      max: ''
    }]
  }, {
    child: [{
      min: '0',
      max: ''
    }]
  }, {
    infant: [{
      min: '0',
      max: 'adult'
    }]
  }],
  placepickerConfig: [{
    cookie: [{
      recentSearchCookie: 'flightRecentSearch'
    }]
  }, {
    recommendedStations: [{
      stationName: 'Singapore'
    }, {
      stationName: 'Kuala Lumpur'
    }, {
      stationName: 'India'
    }, {
      stationName: 'Europe'
    }]
  }],
  gtmConfig: [{
    data: [{
      event: 'trackEventNoEcommerce',
      eventActionClick: 'click',
      eventActionView: 'view',
      eventCategory: '',
      eventLabelCardClick: '',
      eventLabelHeadlineClick: ''
    }]
  }],
  translations: [{
    data: [{
      calendarSubmitButton: 'Confirm',
      calendarResetButton: 'Reset',
      adultSingle: 'Adult',
      adultPlural: 'Adults',
      airAsiaOnly: 'Airasia Flight Only',
      childSingle: 'Child',
      childPlural: 'Children',
      infantSingle: 'Infant',
      infantPlural: 'Infants',
      guestSingle: '{{count}} Guest',
      guestPlural: '{{count}} Guests',
      roomSingle: 'Room',
      roomPlural: 'Rooms',
      adultAgeLimit: '12 years and above',
      childAgeLimit: '2 to 11 years',
      infantAgeLimit: 'Below 2 years',
      roomTitle: 'Room {0}',
      roomAddButton: 'Add more rooms',
      roomRemoveButton: 'Remove',
      roomSubmitButton: 'Done',
      noResultLabel: "Oh my, we couldn't find anything for {0}",
      lowestFareLabel: 'Lowest all-in fares in {0} for 1 adult',
      noFareLabel: 'Unable to display the lowest fares',
      passengerModalHeaderLabel: 'Number of guests and rooms',
      bigLoyaltyToggleLabel: 'Redeem BIG Points',
      recentSearchLabel: 'Recent searches',
      nearestAirportLabel: 'Nearest airports',
      loadOptions: 'Hang in there. Looking up some cool desitnations for you.',
      paxSelectorLabel: 'Guests',
      heroBannerUrl: 'https://a.staticaa.com/images/web-apps/component/flight-search/Generic-Flight-Mobile-Web-Banner.png',
      snapCheckboxTitle: 'SNAP (Flights + Hotel)',
      snapCheckboxLabel: 'Add a hotel and save up to 25% on flights',
      travelClassTitle: 'Travel Class'
    }]
  }],
  chinaDisclaimer: [{
    data: [{
      cnDisclaimerLine1: '请稍候，您将于 {3} 秒后由 {0} 网站跳转至中国境外网站 {1}。',
      cnDisclaimerLine2: '您的交易是直接与中国境外网站 {1} 的运营主体 {2} 构成合同关系，与亚航商务服务(广州)有限公司无关。',
      cnDisclaimerURL: 'airasia.cn',
      countDownTimer: '5',
      redirectCompanyName: 'Kiwi.com',
      redirectCompanyURL: 'flybeyond.airasia.com',
      redirectionUrl: '',
      productID: 'flights',
      newTab: 'TRUE'
    }]
  }],
  ENDPOINT_CONFIG: [{
    data: [{
      id: 'origin',
      endpointID: 'origin',
      endpointUrl: '{static_url}/flights/station/v2/{locale}/file.json'
    }, {
      id: 'destination',
      endpointID: 'destination',
      endpointUrl: '{static_url}/flights/v2/destination/{iata}/file.json'
    }, {
      id: 'datepicker',
      endpointID: 'oneway',
      endpointUrl: ''
    }, {
      id: 'datepicker',
      endpointID: 'return',
      endpointUrl: ''
    }, {
      id: 'dateFormat',
      endpointID: 'dateFormat',
      endpointUrl: '{static_url}/cosmos/common/date/{locale}/file.json'
    }, {
      id: 'dateFormatStatic',
      endpointID: 'dateFormatStatic',
      endpointUrl: '{static_url}/cosmos/common/date/{locale}/file.json'
    }, {
      id: 'multiCurrency',
      endpointID: 'multiCurrency',
      endpointUrl: '{kong_url}/multicurrency/{currency}'
    }, {
      id: 'nearestAirport',
      endpointID: 'nearestAirport',
      endpointUrl: 'https://t.airasia.com/nearestairport/airport/user'
    }, {
      id: 'featureFlag',
      endpointID: 'featureFlag',
      endpointUrl: '{static_url}/flights/platform/featureflags/search/{feature_flag_env}/file.json'
    }, {
      id: 'searchDeepLink',
      endpointID: 'searchDeepLink',
      endpointUrl: '{kong_url}/deeplink/v1/encryptdeeplink'
    }, {
      id: 'dataVisor',
      endpointID: 'dataVisor',
      endpointUrl: '{kong_url}/bizsecrisk'
    }, {
      id: 'baseCurrency',
      endpointID: 'baseCurrency',
      endpointUrl: '{kong_url}/basecurrency/{IATA}'
    }, {
      id: 'otaGeoidFunnel',
      endpointID: 'otaGeoidFunnel',
      endpointUrl: '{static_url}/flights/ota/geoid/geoids/file.json'
    }, {
      id: 'originCity',
      endpointID: 'origin',
      endpointUrl: '{static_url}/flights/station/v3/{locale}/file.json'
    }, {
      id: 'destinationCity',
      endpointID: 'destination',
      endpointUrl: '{static_url}/flights'
    }, {
      id: 'airportSearch',
      endpointID: 'airportSearch',
      endpointUrl: '{flights_api_url}/travel/stations'
    }]
  }],
  tripTypeConfig: [{
    data: [{
      label: 'Round-trip',
      selectionType: 'select',
      code: 'R',
      url: ''
    }, {
      label: 'One-way',
      selectionType: 'select',
      code: 'O',
      url: ''
    }, {
      label: 'Multi-city',
      selectionType: 'redirect',
      code: 'M',
      url: 'https://flybeyond.airasia.com/en/landing/multicity'
    }]
  }],
  aaiDisclaimer: [{
    data: [{
      cnDisclaimerLine1: 'Just a moment. We’re redirecting you to airasia.co.in in {3} seconds.',
      cnDisclaimerLine2: ' ',
      cnDisclaimerURL: 'airasia.co.in',
      countDownTimer: '5',
      redirectCompanyName: 'AirAsiaIndia',
      redirectCompanyURL: 'airasia.co.in',
      redirectionUrl: '',
      productID: 'flights',
      newTab: 'TRUE'
    }]
  }],
  travelClassConfig: [{
    data: [{
      title: 'Economy',
      value: 'economy',
      code: 'M'
    }, {
      title: 'Business',
      value: 'business',
      code: 'C'
    }, {
      title: 'Premium Economy',
      value: 'premium',
      code: 'W'
    }, {
      title: 'First Class',
      value: 'first',
      code: 'F'
    }]
  }]
};
exports.DEFAULT_DATA = DEFAULT_DATA;